export default "__VITE_ASSET__CSLjnC98__"